<template>
  <div class="reportManage">
    <div class="breadcrumb">举报审核</div>
    <div class="search">
      时间：
      <div class="time">
        <el-date-picker
          type="date"
          v-model="beginAt"
          format="yyyy/MM/dd"
          placeholder="请选择开始时间"
          class="qizhiDate"
        ></el-date-picker>
      </div>
      -
      <div class="time">
        <el-date-picker
          type="date"
          v-model="endAt"
          format="yyyy/MM/dd"
          placeholder="请选择结束时间"
          class="qizhiDate"
        ></el-date-picker>
      </div>
      状态：
      <div class="time">
        <el-select v-model="status">
          <el-option value="0" label="全部状态"></el-option>
          <el-option value="2" label="已通过"></el-option>
          <el-option value="3" label="未通过"></el-option>
          <el-option value="1" label="未审核"></el-option>
        </el-select>
      </div>

      <el-button type="primary" @click="getList">搜索</el-button>
    </div>

    <div class="com-list">
      <el-table
        :data="list"
        style="overflow-x: auto"
        :row-class-name="tableRowClassName"
      >
        <el-table-column type="index" label="序号" width="80px;">
        </el-table-column>
        <el-table-column prop="reportId" label="举报人ID" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="reportNum" label="举报人数"> </el-table-column>
        <el-table-column
          prop="cheatReason"
          label="作弊说明 "
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="reportTimeText"
          label="举报时间"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column inline-template label="审核状态">
          <div>
            <div v-if="row.status == 2">已通过</div>
            <div v-if="row.status == 3">未通过</div>
            <div v-if="row.status == 1">未审核</div>
          </div>
        </el-table-column>
        <el-table-column label="操作" inline-template>
          <div>
            <el-button
              class="option"
              type="text"
              @click="showImg(row.imageUrls)"
              >详情</el-button
            >
            <el-button
              class="option"
              type="text"
              @click="passOperate(row, 2)"
              v-if="row.status !== 2"
              >通过</el-button
            >
            <el-button
              class="option"
              type="text"
              @click="passOperate(row, 3)"
              v-if="row.status == 1"
              >不通过</el-button
            >
          </div>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          v-show="this.totalCount > 0"
          layout="prev, pager, next, jumper"
          :page-size="10"
          :current-page="currentPage"
          :total="totalCount"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      title="详情"
      v-model="dialogFormVisible"
      :modal-append-to-body="false"
    >
      <div style="text-align: center">
        <img :src="item" v-for="item in imageUrls" class="img" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      beginAt: new Date(),
      endAt: new Date(),
      status: "0",
      dialogFormVisible: false,
      imageUrls: [],
      list: [],
      currentPage: 1,
      totalCount: 0,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    //获取审核列表
    getList() {
      let startTime =
        new Date(
          new Date(this.beginAt).format("yyyy/MM/dd 00:00:00")
        ).getTime() * 1;
      let endTime =
        new Date(new Date(this.endAt).format("yyyy/MM/dd 23:59:59")).getTime() *
        1;

      if (!this.beginAt || !this.endAt) {
        return;
      }

      if (startTime > endTime) {
        this.$util.errorMsg("搜索的开始时间不可以大于结束时间");
        return;
      }

      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v4/user/reportmanage/list",
        body: JSON.stringify({
          startTime,
          endTime,
          examineType: this.status * 1,
          pageNum: this.currentPage,
          pageSize: 10,
        }),
      }).then((response) => {
        this.list = [];
        if (response.data.error === 10000) {
          let list = response.data.data.list;
          this.list = list;
          this.list.forEach((item) => {
            item.reportTimeText = new Date(item.reportTime).format(
              "yyyy/MM/dd"
            );
          });
          this.totalCount = response.data.data.totalCount;
        } else {
          this.$util.errorMsg(response.data.message);
        }
      });
    },
    showImg(imageUrls) {
      this.imageUrls = imageUrls;
      this.dialogFormVisible = true;
    },
    //通过与不通过；2-通过，3-不通过；
    passOperate(row, status) {
      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v4/user/report/passaction",
        body: JSON.stringify({
          status,
          reportTime: row.reportTime,
          reportId: row.reportId,
        }),
      }).then((response) => {
        if (response.data.error === 10000) {
          let data = response.data.data;
          this.$util.successMsg("操作成功");
          this.getList();
        }
      });
    },
    //请求分页数据
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
};
</script>
<style>
.reportManage {
  padding-bottom: 40px;
}

.reportManage .el-select {
  display: inline-block;
  width: 200px;
}

.reportManage .el-button {
  display: inline-block;
}

.reportManage .el-button + .el-button {
  margin-left: 0;
}

.search {
  margin-left: 30px;
  margin-bottom: 20px;
}

.el-dialog__body p {
  line-height: 38px;
}

.reportManage .time {
  display: inline-block;
  width: 200px;
}

.reportManage .img {
  display: inline-block;
  width: 150px;
  height: 150px;
  margin-left: 10px;
  cursor: pointer;
}

.reportManage .right {
  float: right;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// reportManage.vue?6b1e5642